// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  BugReportStatus,
  ReportKind,
  Priority,
} from "./types";

export default {
  reportId: __t.u64(),
  get newKind() {
    return __t.option(ReportKind);
  },
  get newPriority() {
    return __t.option(Priority);
  },
  newCategory: __t.option(__t.string()),
  get newStatus() {
    return __t.option(BugReportStatus);
  },
};
